import React, { useRef, useEffect, useState, useMemo } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Form, Input, message } from "antd";
import { CustomLabel, BookAppointmentButton } from "../../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  pickerOptionsHours,
  pickerOptionsMinutes,
  getMaxDate,
  getMinDate,
  getRoundHourForTele,
  isSameDateSelected,
  getAllowedStartingHour,
} from "./handlers";
import {
  setAppointmentDate,
  setLanguage,
  setAppointmentTime,
  setIsModalOpen,
  setCallMode,
  setVhSlots,
  setVhMinDate,
  setVhMaxDate,
} from "../../../../Redux/BookTeleMedical/action";
import AppointmentModal from "../AppointmentModal";
import { PolicyDetails, TeleUwDetails } from "../../CommonData";
import DatePicker from "react-date-picker/dist/entry.nostyle";
import CONSTANTS from "../../../../Utils/constant";
import { calenderBlueIcon } from "../../../../Assets/Images";
import {
  convertTo24Hour,
  getGender,
  maskedEmail,
  maskPhoneNumber,
} from "../../../../Utils";
import PAGE_CONSTANTS from "../constant";
import { error_message, status_code_constant_data } from "../../../../Constant";
import { statusCode_Info } from "../../PolicyPendingPage/StatusTable";
import { decrypt, encrypt } from "../../../../Services/AESEncryptionDecryption";
import { postApi } from "../../../../Services/apiService";
import { GET_TELE_VH_SLOTS } from "../../../../Services/endpoints";
import { mockSlots } from "./data";
import "./bookTele.css";

const BookTeleMedical = ({ bookAppointment }) => {
  const dispatch = useDispatch();
  const {
    proposalDetails,
    policyType,
    businessType,
    inwardTypeCode,
    proposerCity,
    proposerFirstName,
    proposerInitial,
    proposerLastName,
    proposerState,
    proposerArea,
    policyNum,
    applicationID,
    agentMobileNumber,
    agentName,
    channel,
    agent,
    premium,
    branchMaster,
    zone,
    portability,
  } = PolicyDetails();
  const [isDisablePM, setIsDisablePM] = useState(false);
  const [isDisableAM, setIsDisableAM] = useState(false);
  const [bufferHours, setBufferHours] = useState(2);

  const {
    appointmentDate,
    appointmentTime,
    language,
    isModalOpen,
    callMode,
    tpaDetails,
    vhSlots: slots,
    vhMinDate,
    vhMaxDate,
    isInstantMode,
  } = TeleUwDetails();
  const isTpaVisitHealth = tpaDetails === PAGE_CONSTANTS?.TPA_VH;
  const isInstantSelected = callMode === CONSTANTS?.INSTANT;
  const isTodaysDateSelected = isSameDateSelected(appointmentDate);
  const roundedHour = getRoundHourForTele();

  const getLanguageOptions = () => {
    switch (tpaDetails) {
      case PAGE_CONSTANTS?.TPA_HA:
        return PAGE_CONSTANTS?.LANGUAGE_DROPDOWN_OPTIONS_HA;
      case PAGE_CONSTANTS?.TPA_HI:
        return PAGE_CONSTANTS?.LANGUAGE_DROPDOWN_OPTIONS_HI;
      case PAGE_CONSTANTS?.TPA_VH:
        return PAGE_CONSTANTS?.LANGUAGE_DROPDOWN_OPTIONS_VH;
      default:
        return [];
    }
  };
  const toggleModal = () => {
    dispatch(setIsModalOpen({ value: !isModalOpen }));
  };
  const onTimeChange = (type, value) => {
    switch (type) {
      case "HOUR":
        const isResetMinute =
          value === "08" &&
          appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM;
        dispatch(
          setAppointmentTime({
            value: {
              ...appointmentTime,
              ...(isResetMinute && { minute: `00` }),
              hour: value,
            },
          })
        );
        break;
      case "MINUTE":
        dispatch(
          setAppointmentTime({
            value: {
              ...appointmentTime,
              minute: value,
            },
          })
        );
        break;
      case "MERIDIEM":
        dispatch(
          setAppointmentTime({
            value: {
              hour: pickerOptionsHours(
                value,
                bufferHours,
                isTodaysDateSelected
              )?.[0],
              minute: `00`,
              meridiem: value,
            },
          })
        );
        break;
      default:
        break;
    }
  };
  const onDateChange = (e) => {
    dispatch(
      setAppointmentDate({ value: moment(e).format(CONSTANTS.FORMAT_DOB) })
    );
  };
  const getLanguageValue = (language) => {
    return getLanguageOptions()?.find((item) => item?.label === language)
      ?.value;
  };
  const onLanguageChange = (e) => {
    dispatch(setLanguage({ value: e?.target?.value }));
    if (tpaDetails === PAGE_CONSTANTS?.TPA_VH && !isInstantSelected) {
      getVhSlotDetails(e?.target?.value);
    }
  };
  const onCallModeChange = (value) => {
    dispatch(setCallMode({ value }));
  };
  const datepickerRefApt = useRef(null);
  function handleClickDatepickerIcon(datePicker) {
    const datepickerElement = datePicker.current;
    datepickerElement.toggleCalendar();
  }
  const getVhSlotId = () => {
    const removeZeroFromHour = Number(appointmentTime?.hour?.[0])
      ? appointmentTime?.hour
      : appointmentTime?.hour?.[1];
    const time = `${removeZeroFromHour}:${appointmentTime?.minute}${appointmentTime?.meridiem}`;
    const selectedDate = moment(appointmentDate, CONSTANTS?.FORMAT_DOB)?.format(
      CONSTANTS?.FORMAT_SLOT_DATE
    );
    const todaySlots = slots?.filter(
      (item) =>
        item?.slotDate === selectedDate &&
        item?.slotEndTimestamp?.includes(appointmentTime?.meridiem)
    );
    const findByStart = todaySlots?.find(
      (slot) => slot?.slotStartTimestamp === time
    );
    const findByEnd = todaySlots?.find(
      (slot) => slot?.slotEndTimestamp === time
    );
    return findByStart?.slotId || findByEnd?.slotId || "";
  };
  const onFinish = (values) => {
    toggleModal();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const getName = (value) => {
    return value ? `${value} ` : "";
  };
  const filteredTeleUwList = proposalDetails?.MemberDetails?.filter((item) =>
    statusCode_Info(item, status_code_constant_data?.TeleUW)
  );
  const insuredNames = filteredTeleUwList?.map(
    (mem) =>
      `${getName(mem?.FirstName)}${getName(mem?.MiddleName)}${getName(
        mem?.LastName
      )}`
  );
  const getInsuredMemberObj = (memberDetails) => {
    return {
      Member_Id: memberDetails?.MemberId,
      Insured_Id: memberDetails?.CustomerId || "",
      Insured_Initial: memberDetails?.InsuredInitial,
      Insured_First_Name: memberDetails?.FirstName,
      Insured_Middle_Name: memberDetails?.MiddleName,
      Insured_Last_Name: memberDetails?.LastName,
      Insured_Mobile_Number: proposalDetails?.ProposerMobile,
      Insured_Residence_Number: "",
      Insured_Office_Number: "-",
      Insured_Email_id: proposalDetails?.ProposerEmail,
      Insured_Pincode: "",
      Insured_State: memberDetails?.InsuredState,
      Insured_Landmark: "",
      Insured_City: memberDetails?.InsuredCity,
      Insured_Address1: "",
      Insured_Address2: "",
      Insured_Address3: "",
      Insured_Dob: moment(
        memberDetails?.InsuredDob,
        CONSTANTS?.FORMAT_DOB
      ).format(CONSTANTS?.FORMAT_DOB_SLASH),
      Insured_Age: memberDetails?.InsuredAge,
      Insured_Gender: getGender(memberDetails?.InsuredGender),
      Priority_HNI_Flag: false,
      Appointment_Type: "TELEUW",
      Tele_Required_Flag: true,
      Appointment_Preferred_Date1: !isInstantSelected
        ? moment(appointmentDate, CONSTANTS?.FORMAT_DOB).format(
            CONSTANTS?.FORMAT_DOB_SLASH
          )
        : "",
      Appointment_Preferred_Time1: !isInstantSelected
        ? convertTo24Hour(
            appointmentTime?.hour,
            appointmentTime?.minute,
            appointmentTime?.meridiem
          )
        : "",
      Appointment_Preferred_Date2: "",
      Appointment_Preferred_Time2: "00:00:00",
      Appointment_Preferred_Date3: "",
      Appointment_Preferred_Time3: "00:00:00",
      AddField1: "",
      AddField2: "",
    };
  };
  const getInsuredMemberInfo = () => {
    const insuredMembersList = filteredTeleUwList?.map((memberDetails) =>
      getInsuredMemberObj(memberDetails)
    );
    return insuredMembersList;
  };
  const handleAppointmentBooking = () => {
    const requestPayload = {
      Tpa_code: tpaDetails,
      Application_Number: applicationID,
      PolicyType: policyType,
      Business_Type: businessType || "Urban",
      Inward_Type: inwardTypeCode,
      Policy_Number: policyNum,
      HNIFlag: "NO",
      Proposer_Initial: proposerInitial,
      Proposer_Name: `${proposerFirstName} ${proposerLastName}`,
      Proposer_Mobile_Number: proposalDetails?.ProposerMobile,
      Proposer_Email: proposalDetails?.ProposerEmail,
      Proposer_City: proposerCity,
      Proposer_State: proposerState,
      Proposer_Area: proposerArea,
      AddField1: "",
      AddField2: "",
      Source: "APPTRACKER",
      Sub_Plan_Name: "",
      Proposal_Status: "",
      Branch_Name: "",
      Branch_Code: branchMaster,
      Agent_FirstName: agentName,
      Agent_LastName: null,
      Agent_Code: agent,
      Agent_Mobile_No: agentMobileNumber,
      Agent_Email: "",
      RM_FirstName: "",
      RM_LastName: null,
      RM_Contact_Number: "",
      RM_Email: null,
      Portability: portability,
      Preferred_Language: getLanguageValue(language),
      Proposal_Comment_Reason: null,
      SumInsured: "",
      Channel: channel,
      Zone: zone,
      Premium: premium,
      IsInstant: isInstantSelected,
      slotId: isInstantSelected || !isTpaVisitHealth ? "" : getVhSlotId(),
      language: getLanguageValue(language),
      Insured_Info: getInsuredMemberInfo(),
    };
    if (getInsuredMemberInfo()?.length) {
      bookAppointment(requestPayload);
      toggleModal();
    }
  };
  const calculateVhDates = (slotsList) => {
    const dates = new Set(slotsList?.map((item) => item?.slotDate));
    const sortedDateList = [...dates]?.sort();
    const maxDate = moment(
      sortedDateList[sortedDateList?.length - 1],
      CONSTANTS?.FORMAT_SLOT_DATE
    ).format(CONSTANTS?.FORMAT_SLOT_DATE);
    //SET VH MAX DATE
    dispatch(setVhMaxDate({ value: maxDate }));
    //SET VH MIN DATE
    if (sortedDateList[0] === moment()?.format(CONSTANTS?.FORMAT_SLOT_DATE)) {
      const dateSlots = slotsList?.filter(
        (item) => item?.slotDate === sortedDateList[0]
      );
      const availableSlots = dateSlots?.map((item) => item?.slotEndTimestamp);
      const allowed = getAllowedStartingHour(1);
      const allowedStartingSlot = `${allowed?.hour}:00${allowed?.meridiem}`;
      const isAllowedTodayBooking =
        availableSlots?.includes(allowedStartingSlot);
      if (isAllowedTodayBooking) {
        dispatch(
          setVhMinDate({ value: moment().format(CONSTANTS?.FORMAT_SLOT_DATE) })
        );
        dispatch(
          setAppointmentDate({
            value: moment(moment().toDate()).format(CONSTANTS.FORMAT_DOB),
          })
        );
        dispatch(
          setAppointmentTime({
            value: {
              hour: pickerOptionsHours(
                allowed?.meridiem,
                1,
                isTodaysDateSelected
              )?.[0],
              minute: `00`,
              meridiem: allowed?.meridiem,
            },
          })
        );
      } else {
        dispatch(
          setVhMinDate({
            value: moment().add(1, "days").format(CONSTANTS?.FORMAT_SLOT_DATE),
          })
        );
        dispatch(
          setAppointmentDate({
            value: moment(moment().add(1, "days").toDate()).format(
              CONSTANTS.FORMAT_DOB
            ),
          })
        );
      }
    } else {
      dispatch(
        setVhMinDate({
          value: moment(sortedDateList[0], CONSTANTS?.FORMAT_SLOT_DATE).format(
            CONSTANTS?.FORMAT_SLOT_DATE
          ),
        })
      );
    }
  };
  const getVhSlotDetails = async (language) => {
    try {
      const payload = {
        applicationNumber: policyNum,
        language: getLanguageValue(language),
      };
      const encodedPayload = encrypt(JSON.stringify(payload));
      const result = await postApi(GET_TELE_VH_SLOTS, {
        encodedString: encodedPayload,
      });
      if (result?.data?.response) {
        const decryptedResponse = JSON?.parse(decrypt(result?.data?.response));
        dispatch(setVhSlots({ value: decryptedResponse?.slot }));
        if(!decryptedResponse?.slot?.length){
          setVhMinDate({
            value: moment().format(CONSTANTS?.FORMAT_SLOT_DATE),
          })
        }
        else{
          calculateVhDates(decryptedResponse?.slot);
        }
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };

  const minimumDate = useMemo(() => {
    return isTpaVisitHealth
      ? moment(vhMinDate, CONSTANTS?.FORMAT_SLOT_DATE)?.toDate()
      : getMinDate(bufferHours);
  }, [isTpaVisitHealth, vhMinDate, bufferHours]);

  const maximumDate = useMemo(() => {
    return isTpaVisitHealth && slots?.length
      ? moment(vhMaxDate, CONSTANTS?.FORMAT_SLOT_DATE)?.toDate()
      : getMaxDate(bufferHours);
  }, [isTpaVisitHealth, vhMinDate, bufferHours, slots]);
  
  const disableSundays = ({ date }) => {
    return !isTpaVisitHealth && date?.getDay() === 0;
  }

  const getHourOptions = () => {
    const pickerHours = pickerOptionsHours(
      appointmentTime?.meridiem,
      bufferHours,
      isTodaysDateSelected
    );
    if (isTodaysDateSelected && tpaDetails === PAGE_CONSTANTS?.TPA_VH) {
      const selectedDate = moment(
        appointmentDate,
        CONSTANTS?.FORMAT_DOB
      )?.format(CONSTANTS?.FORMAT_SLOT_DATE);
      const todaySlots = slots?.filter(
        (item) =>
          item?.slotDate === selectedDate &&
          item?.slotEndTimestamp?.includes(appointmentTime?.meridiem)
      );
      const convertedSlots = new Set(
        todaySlots?.map((item) => {
          const hour = item?.slotEndTimestamp?.split(":")[0];
          return hour?.length > 1 ? hour : `0${hour}`;
        })
      );
      const uniqueConvertedHours = [...convertedSlots];
      return pickerHours?.filter((hour) =>
        uniqueConvertedHours?.includes(hour)
      );
    } else {
      return pickerHours;
    }
  };
  const getMinuteOptions = () => {
    const pickerMinutes = pickerOptionsMinutes(
      appointmentTime?.hour === "08" &&
        appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM
    );
    if (isTodaysDateSelected && tpaDetails === PAGE_CONSTANTS?.TPA_VH) {
      const removeZeroFromHour = Number(appointmentTime?.hour?.[0])
        ? appointmentTime?.hour
        : appointmentTime?.hour?.[1];
      const selectedDate = moment(
        appointmentDate,
        CONSTANTS?.FORMAT_DOB
      )?.format(CONSTANTS?.FORMAT_SLOT_DATE);
      const todaySelectedHoursSlots = slots?.filter(
        (item) =>
          item?.slotDate === selectedDate &&
          item?.slotEndTimestamp?.includes(appointmentTime?.meridiem) &&
          item?.slotEndTimestamp?.split(":")[0] === removeZeroFromHour
      );
      const convertedMinuteOptions = todaySelectedHoursSlots?.map(
        (today) =>
          today?.slotEndTimestamp
            ?.split(":")[1]
            ?.split(appointmentTime?.meridiem)[0]
      );
      return convertedMinuteOptions?.map((optionValue) => {
        return (
          <option key={optionValue} value={optionValue}>
            {optionValue}
          </option>
        );
      });
    } else {
      return pickerMinutes;
    }
  };
  useEffect(() => {
    const isVisitTpa = tpaDetails === PAGE_CONSTANTS?.TPA_VH;
    const calculateBuffer = isVisitTpa ? 1 : 2;
    setBufferHours(calculateBuffer);
    const allowed = getAllowedStartingHour(calculateBuffer);
    //SETTING LANGUAGE
    if (!language) {
      dispatch(setLanguage({ value: getLanguageOptions()?.[0]?.label }));
      if (isVisitTpa && getLanguageOptions()?.[0]?.label) {
        getVhSlotDetails(getLanguageOptions()?.[0]?.label);
      }
    }
    //SETTING DATE TIME IF NOT VISIT TPA
    if (!isVisitTpa) {
      dispatch(
        setAppointmentDate({
          value: moment(getMinDate(calculateBuffer)).format(
            CONSTANTS.FORMAT_DOB
          ),
        })
      );
      dispatch(
        setAppointmentTime({
          value: {
            hour: pickerOptionsHours(
              allowed?.meridiem,
              calculateBuffer,
              isTodaysDateSelected
            )?.[0],
            minute: `00`,
            meridiem: allowed?.meridiem,
          },
        })
      );
    }
  }, [tpaDetails]);

  useEffect(() => {
    if (isTodaysDateSelected) {
      const allowed = getAllowedStartingHour(bufferHours);
      if (allowed?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM) {
        setIsDisableAM(true);
        onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_PM);
      } else {
        setIsDisableAM(false);
        onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_AM);
      }
    } else {
      setIsDisableAM(false);
      dispatch(
        setAppointmentTime({
          value: {
            hour: "09",
            minute: "00",
            meridiem: "AM",
          },
        })
      );
    }
  }, [appointmentDate]);

  useEffect(() => {
    //RESET DATE TIME WHEN SAME DATE AND SLOT TIME IS BEYOND 8PM
    if (isTodaysDateSelected && roundedHour + bufferHours > 20) {
      dispatch(setAppointmentDate({ value: null }));
      setIsDisableAM(false);
      onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_AM);
    }
  }, [isTodaysDateSelected, roundedHour, bufferHours]);

  useEffect(() => {
    if (getHourOptions()?.length === 0) {
      if (tpaDetails === PAGE_CONSTANTS?.TPA_VH && isTodaysDateSelected) {
        dispatch(
          setVhMinDate({
            value: moment().add(1, "days").format(CONSTANTS?.FORMAT_SLOT_DATE),
          })
        );
        dispatch(
          setAppointmentDate({
            value: moment().add(1, "days").format(CONSTANTS.FORMAT_DOB),
          })
        );
        dispatch(
          setAppointmentTime({
            value: {
              hour: "09",
              minute: "00",
              meridiem: "AM",
            },
          })
        );
      }
    }
  }, [getHourOptions]);

  const renderTeleBookContent = () => {
    return (
      <>
        {isInstantMode && (
          <div
            className="tele_booking_detail"
            style={{ paddingLeft: "0px", marginBottom: "24px", width: "unset" }}
          >
            <input
              className="titleRadio"
              id={"schedule"}
              value={"Schedule Call"}
              type="radio"
              checked={callMode === CONSTANTS?.SCHEDULE}
              required
              onChange={() => {}}
              name="callLater"
              data-validation="required"
            />
            <label
              onClick={() => onCallModeChange(CONSTANTS?.SCHEDULE)}
              className="cigna_button"
              style={{
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
              {"Schedule Call"}
            </label>
            <input
              className="titleRadio"
              id={"instant"}
              value={"Instant Call"}
              checked={callMode === CONSTANTS?.INSTANT}
              type="radio"
              required
              onChange={() => {}}
              name="callNow"
              data-validation="required"
            />
            <label
              onClick={() => onCallModeChange(CONSTANTS?.INSTANT)}
              className={"cigna_button"}
              style={{
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              {"Instant Call"}
            </label>
          </div>
        )}
        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginBottom: "16px" }}
        >
          {"Please Enter Below Details"}
        </CustomLabel>
        <Form
          name="bookVisit"
          autoComplete="off"
          className="house-visit-book"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <CustomLabel
            font_size="18"
            font_weight="bold"
            style={{ marginTop: "24px", marginBottom: "10px" }}
          >
            {"1. Select Preferred Language"}
          </CustomLabel>
          <label className="input_other">
            <select
              name="language"
              id="language"
              className="language-pick-dropdown"
              value={language}
              onChange={onLanguageChange}
            >
              {getLanguageOptions()?.map((language, index) => (
                <option
                  key={`${language?.label}-${index}`}
                  value={language?.label}
                >
                  {language?.label}
                </option>
              ))}
            </select>
          </label>
          {callMode === CONSTANTS?.SCHEDULE && (
            <>
              <CustomLabel
                font_size="18"
                font_weight="bold"
                style={{ marginTop: "24px", marginBottom: "10px" }}
              >
                {"2. Select Preferred Date"}
              </CustomLabel>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "24px",
                }}
              >
                <div className="input pl-2 pr-2 date_open">
                  <DatePicker
                    ref={datepickerRefApt}
                    calendarType={"US"}
                    id={"appointmentDate"}
                    onChange={onDateChange}
                    value={
                      appointmentDate
                        ? moment(appointmentDate, CONSTANTS?.FORMAT_DOB).toDate()
                        : ""
                    }
                    clearIcon={null}
                    minDate={minimumDate}
                    maxDate={maximumDate}
                    defaultView="month"
                    calendarIcon={null}
                    format="dd/MM/yyyy"
                    dayPlaceholder="DD"
                    monthPlaceholder="MM"
                    yearPlaceholder="YYYY"
                    tileDisabled={disableSundays}
                  />
                </div>
                <span className="open_picker" style={{ paddingLeft: "10px" }}>
                  <img
                    src={calenderBlueIcon}
                    onClick={() => handleClickDatepickerIcon(datepickerRefApt)}
                    alt="calendar"
                  />
                </span>
              </div>
              <CustomLabel
                font_size="18"
                font_weight="bold"
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                {"3. Select Preferred Time"}
              </CustomLabel>
              <div className="input_wrap time-picker-container">
                <label className="input_other">
                  <select
                    name="hour"
                    id="hourTime"
                    className="time-pick-dropdown"
                    data-validation="required"
                    value={appointmentTime?.hour}
                    onChange={(e) => onTimeChange("HOUR", e?.target?.value)}
                  >
                    {getHourOptions()?.map((item, index) => (
                      <option key={item + index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </label>
                <label className="input_other ml-1">
                  <select
                    name="minutes"
                    id="minutesTime"
                    className="time-pick-dropdown"
                    value={appointmentTime?.minute}
                    onChange={(e) => onTimeChange("MINUTE", e?.target?.value)}
                  >
                    {getMinuteOptions()}
                  </select>
                </label>
                <div
                  className="mt_booking_detail"
                  style={{ paddingLeft: "0px", width: "unset" }}
                >
                  <input
                    className="titleRadio"
                    id={"am"}
                    value={"AM"}
                    type="radio"
                    checked={
                      appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM
                    }
                    required
                    onChange={() => {}}
                    name="nameTitle"
                    data-validation="required"
                  />
                  <label
                    onClick={
                      !isDisableAM
                        ? () =>
                            onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_AM)
                        : null
                    }
                    className={
                      isDisableAM
                        ? "cigna_button meridiem-disable"
                        : "cigna_button"
                    }
                    style={{
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                    }}
                  >
                    {"AM"}
                  </label>
                  <input
                    className="titleRadio"
                    id={"pm"}
                    value={"PM"}
                    checked={
                      appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM
                    }
                    type="radio"
                    required
                    onChange={() => {}}
                    name="nameTitle"
                    data-validation="required"
                  />
                  <label
                    onClick={
                      !isDisablePM
                        ? () =>
                            onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_PM)
                        : null
                    }
                    className={
                      isDisablePM
                        ? "cigna_button meridiem-disable"
                        : "cigna_button"
                    }
                    style={{
                      borderBottomLeftRadius: 0,
                      borderTopLeftRadius: 0,
                    }}
                  >
                    {"PM"}
                  </label>
                </div>
              </div>
            </>
          )}
          <CustomLabel
            font_size="16"
            font_weight="bold"
            style={{ marginTop: "20px", marginBottom: "20px" }}
          >
            {"Insured Details"}
          </CustomLabel>
          <ul style={{ paddingLeft: "20px", marginBottom: "30px" }}>
            {insuredNames?.map((name, index) => {
              return (
                <li key={index}>
                  <CustomLabel
                    font_size="14"
                    font_weight="bold"
                    style={{ marginBottom: "10px" }}
                  >
                    {name}
                  </CustomLabel>
                </li>
              );
            })}
          </ul>
  
          <Row gutter={[10, 10]}>
            <Col sm={12} md={9}>
              <CustomLabel
                font_size="16"
                font_weight="bold"
                style={{ marginBottom: "10px" }}
              >
                {"Mobile"}
              </CustomLabel>
              <div className="input_wrap">
                <Input
                  type="tel"
                  placeholder="Mobile"
                  className="input_form"
                  name="mobile"
                  value={maskPhoneNumber(proposalDetails?.ProposerMobile)}
                  data-input="digits"
                  readOnly={true}
                />
                <span className="info_icon">
                  <i className="fa fa-mobile" aria-hidden="true"></i>
                </span>
              </div>
            </Col>
            <Col sm={12} md={9}>
              <CustomLabel
                font_size="16"
                font_weight="bold"
                style={{ marginBottom: "10px" }}
              >
                {"Email"}
              </CustomLabel>
              <div className="input_wrap">
                <Input
                  type={"email"}
                  placeholder="Email"
                  className="input_form"
                  name="email"
                  value={maskedEmail(proposalDetails?.ProposerEmail)}
                  readOnly={true}
                />
                <span className="info_icon">
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
              </div>
            </Col>
          </Row>
          <BookAppointmentButton disable={false} style={{ marginTop: "40px" }}>
            <Button type="text" disabled={false} htmlType="submit">
              {"Schedule Call"}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ marginLeft: "15px" }}
              />
            </Button>
          </BookAppointmentButton>
        </Form>
        <AppointmentModal
          open={isModalOpen}
          onClose={toggleModal}
          date={appointmentDate}
          time={appointmentTime}
          language={language}
          mobile={maskPhoneNumber(proposalDetails?.ProposerMobile)}
          email={maskedEmail(proposalDetails?.ProposerEmail)}
          onBooking={handleAppointmentBooking}
          isInstantSelected={isInstantSelected}
        />
      </>
    );
  }
  return filteredTeleUwList?.length > 0 ? (
    renderTeleBookContent()
  ) : (
    <CustomLabel
      font_size="18"
      font_weight="bold"
      style={{ marginBottom: "16px" }}
    >
      {"No Insured found for Tele MER."}
    </CustomLabel>
  );
};

export default BookTeleMedical;
